import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    practiceId: null,
    practiceType: null,
    practiceFormat: null,
    learningMethod: null,
};

const practiceSlice = createSlice({
    name: 'practice',
    initialState,
    reducers: {
        setPractice: {
            reducer(state, action) {
                return { ...state, ...action.payload };
            },
            // Четыре позиционных аргумента — прежняя сигнатура, которой пользуются страницы.
            prepare(practiceId, practiceType, practiceFormat, learningMethod) {
                return { payload: { practiceId, practiceType, practiceFormat, learningMethod } };
            },
        },
        resetPractice() {
            return initialState;
        },
    },
});

export const { setPractice, resetPractice } = practiceSlice.actions;
export default practiceSlice.reducer;
